// extracted by mini-css-extract-plugin
module.exports = {"rotation":"LogoutButton_rotation__CPLgz"};